export const editTabulations = [
  "solicitacao_conta_voebiz_atualizacao_cadastral_atualizacao_cadastral_dados_empresa_voebiz",
  "solicitacao_conta_voebiz_atualizacao_cadastral_atualizacao_cadastral_dados_administrador_voebiz",
];

export const tabulationFieldIdDev = 10815489721495;
export const tabulationFieldIdPrd = 13135104832279;

function envTabulationField(apiDomain: string) {
  const url: string = apiDomain;
  if (url.includes("-hml5") || url.includes("-dev")) {
    return tabulationFieldIdDev;
  }
  return tabulationFieldIdPrd;
}

const checkFieldsForEditTabulation = (ticket: any, apiDomain: string) => {
  if (ticket && ticket.fields) {
    const tabulationField = ticket.fields.find((field: any) => field.id === envTabulationField(apiDomain));

    if (tabulationField) {
      return editTabulations.includes(tabulationField.value);
    }
  }

  return false;
};

export const hasEditUserTicket = (zendesk: any, apiDomain: string) => {
  if (zendesk) {
    let tickets;
    if (Array.isArray(zendesk)) {
      tickets = zendesk;
    } else if (Array.isArray(zendesk.zendesk)) {
      tickets = zendesk.zendesk;
    }

    if (tickets) {
      const notClosed = tickets.filter((ticket: any) => ticket.status !== "closed" && ticket.status !== "resolved");

      if (notClosed.length > 0) {
        const editTicket = notClosed.find((ticket: any) => checkFieldsForEditTabulation(ticket, apiDomain));
        return editTicket !== undefined;
      }
    }
  }

  return false;
};
